<ng-template #modalTmpl>
    <div class="ft-modal2"
         [style.max-width]="maxWidth ? (maxWidth + 'px') : '100%'"
         [style.width]="maxWidth ? '100%' : 'auto'"
         [ngClass]="'-theme_' + theme"
         [class.-slide-up]="enterAnimation === 'slide-up'"
         [hidden]="!customTmpl?.hasChildNodes()"
         #customTmpl>
        <ng-content select="[customTemplate]" />
    </div>
    <ng-content select="[navTemplate]" />
    <button *ngIf="closeButtonVisible"
            class="ft2-btn-close -fixed"
            (click)="close()"></button>
    <ng-container *ngIf="!customTmpl?.hasChildNodes()">
        <div class="ft-modal2"
             [class.-slide-up]="enterAnimation === 'slide-up'"
             [style.width]="maxWidth ? '100%' : 'auto'"
             [style.max-width]="maxWidth ? (maxWidth + 'px') : '100%'">
            <div class="ft-modal2_body">
                <div *ngIf="title || summary"
                     class="ft-modal2_header">
                    <div *ngIf="title"
                         class="ft-modal2_heading">
                        {{ title }}
                    </div>
                    <div *ngIf="summary"
                         class="ft-modal2_summary">
                        {{ summary }}
                    </div>
                </div>
                <ng-content />
                <div class="ft-modal2_footer">
                    <button type="submit"
                            (click)="onDone()"
                            class="ft2-btn-primary -large px-6">
                        Done
                    </button>
                </div>
            </div>
        </div>
    </ng-container>
</ng-template>
<div [hidden]="!triggerTmpl?.hasChildNodes()"
     #triggerTmpl
     (click)="open()">
    <ng-content select="[trigger]" />
</div>
